export const suspensionsIsCanceled = ['cancelled_by_channel'];
